/* globals console: false */

document.addEventListener('DOMContentLoaded', function() {
  const webservicesContainer = document.querySelector('.js-webservices');

  if (webservicesContainer) {
    const webserviceCountries = webservicesContainer.querySelectorAll('h2');
    const webserviceTableOfContentsContainer = webservicesContainer.querySelector('.js-webservices-table-of-contents');
    
    for (var i = 0; i < webserviceCountries.length; i++) {
      const country = webserviceCountries[i];
      const headerOffset = 48;
      const buttonEl = document.createElement('button');

      buttonEl.textContent = webserviceCountries[i].textContent;
      buttonEl.addEventListener('click', function(e) {
        window.scrollTo({
          top: country.getBoundingClientRect().top + window.pageYOffset - headerOffset,
          behavior: "smooth"
        });
      });
      
      webserviceTableOfContentsContainer.append(buttonEl);
    }
  }
});